var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPinMapFillSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5146_20272)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.65 16.7998C4.71986 16.7067 4.81045 16.6311 4.91459 16.579C5.01873 16.5269 5.13357 16.4998 5.25 16.4998H9C9.19891 16.4998 9.38968 16.5788 9.53033 16.7195C9.67098 16.8601 9.75 17.0509 9.75 17.2498C9.75 17.4487 9.67098 17.6395 9.53033 17.7801C9.38968 17.9208 9.19891 17.9998 9 17.9998H5.625L2.25 22.4998H21.75L18.375 17.9998H15C14.8011 17.9998 14.6103 17.9208 14.4697 17.7801C14.329 17.6395 14.25 17.4487 14.25 17.2498C14.25 17.0509 14.329 16.8601 14.4697 16.7195C14.6103 16.5788 14.8011 16.4998 15 16.4998H18.75C18.8664 16.4998 18.9813 16.5269 19.0854 16.579C19.1896 16.6311 19.2801 16.7067 19.35 16.7998L23.85 22.7998C23.9336 22.9112 23.9845 23.0437 23.997 23.1825C24.0095 23.3212 23.9831 23.4606 23.9208 23.5852C23.8585 23.7098 23.7628 23.8146 23.6443 23.8878C23.5258 23.961 23.3893 23.9998 23.25 23.9998H0.75C0.610716 23.9998 0.474184 23.961 0.355702 23.8878C0.23722 23.8146 0.14147 23.7098 0.07918 23.5852C0.0168903 23.4606 -0.00947761 23.3212 0.00303087 23.1825C0.0155393 23.0437 0.06643 22.9112 0.15 22.7998L4.65 16.7998Z",
    fill: "#4BCAE6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 5.99981C6.00011 4.84515 6.33338 3.71504 6.95984 2.7451C7.5863 1.77515 8.47932 1.00657 9.53176 0.53157C10.5842 0.0565725 11.7513 -0.104661 12.8931 0.0672152C14.0349 0.239092 15.1029 0.736778 15.9688 1.50055C16.8348 2.26433 17.462 3.26175 17.7751 4.37314C18.0883 5.48453 18.0741 6.66267 17.7343 7.76619C17.3945 8.86971 16.7434 9.85175 15.8593 10.5944C14.9752 11.3372 13.8956 11.809 12.75 11.9533V20.2498C12.75 20.4487 12.671 20.6395 12.5303 20.7801C12.3897 20.9208 12.1989 20.9998 12 20.9998C11.8011 20.9998 11.6103 20.9208 11.4697 20.7801C11.329 20.6395 11.25 20.4487 11.25 20.2498V11.9548C9.79945 11.7721 8.46553 11.066 7.49882 9.96916C6.53211 8.87236 5.99913 7.46183 6 5.99981Z",
    fill: "#4BCAE6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5146_20272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinMapFillSmall);
export default __webpack_public_path__ + "static/media/pin-map-fill-small.4a5805aa8fd124d665903a79beda983d.svg";
export { ForwardRef as ReactComponent };